import { render, staticRenderFns } from "./EntradasCarritoComponent.vue?vue&type=template&id=46cc2042"
import script from "./EntradasCarritoComponent.vue?vue&type=script&lang=js"
export * from "./EntradasCarritoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports